import { StationContentPreview } from '@/components/station/preview-content';
import { StationForm } from '@/components/station/station-form';
import { cn } from '@/core/ui';
import { useStation } from '@/store/station';

export const Left = () => {
  const preview = useStation.use.preview();
  return (
    <div className={cn('h-full')}>
      <div className={cn({ hidden: preview })}>
        <StationForm />
      </div>
      {preview && <StationContentPreview />}
    </div>
  );
};
